export const SHOWING_TIME = 5000

export const STATUS = {
  CREATED: 0,
  SHOWING: 1,
  HIDING: 2,
  REMOVING: 3
}
